module.exports = __webpack_public_path__ + "static/img/y66.d11e3a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y66.jpg
// module id = dES+
// module chunks = 1